export interface PutAnswer {
  AnswerValue: string;
  AnswerID: string | string[];
  QuestionID: string;
  AnswerType?: string;
  AcccessoryNotListed?: boolean;
}
